// Cent-safe VAT maths for supplier invoice lines. Mirrors DB: amount_vat = round(amount_net * rate / 100, 2).
const cents = (x) => Math.round((Number(x) || 0) * 100);
const eur = (c) => c / 100;
export const VAT_RATES = [0, 9, 13.5, 23];

// Returns { net, vat, gross, entered, roundingDiff } in euros for one line given the entered amount and price mode.
export function lineMoney(amount, rate, mode) {
  const r = Number(rate) || 0; const a = cents(amount);
  if (amount === '' || amount == null || isNaN(Number(amount))) return { net: 0, vat: 0, gross: 0, entered: 0, roundingDiff: 0, empty: true };
  const net = mode === 'inc' ? Math.round(a / (1 + r / 100)) : a;
  const vat = Math.round(net * r / 100);               // what the database will store
  const gross = net + vat;
  const roundingDiff = mode === 'inc' ? gross - a : 0;  // supplier gross vs stored net+VAT (cents)
  return { net: eur(net), vat: eur(vat), gross: eur(gross), entered: eur(a), roundingDiff: eur(roundingDiff) };
}

export function sumLines(lines, mode) {
  return lines.reduce((t, l) => { const m = lineMoney(l.amount, l.vat_rate, mode); return { net: t.net + m.net, vat: t.vat + m.vat, gross: t.gross + m.gross, entered: t.entered + m.entered, roundingDiff: t.roundingDiff + m.roundingDiff }; }, { net: 0, vat: 0, gross: 0, entered: 0, roundingDiff: 0 });
}

// Convert the entered figure so the line keeps the same money when the mode changes (ex→inc: show gross; inc→ex: show net).
export function convertAmount(amount, rate, fromMode) {
  if (amount === '' || amount == null || isNaN(Number(amount))) return amount;
  const m = lineMoney(amount, rate, fromMode);
  return (fromMode === 'ex' ? m.gross : m.net).toFixed(2);
}

export const r2 = (x) => Math.round(x * 100) / 100;
